<script>
import Oidc from 'oidc-client'
import axios from 'axios'

export default {
  name: 'CallbackGerid',
  mounted () {
    let mgr = new Oidc.UserManager({ userStore: new Oidc.WebStorageStateStore(), loadUserInfo: true, filterProtocolClaims: true })
    const hostSeparated = location.host.split('-')
    this.env = hostSeparated?.[0]
    this.tenant = hostSeparated?.[1]
    mgr.signinRedirectCallback().then(async function (user) {
      const result = await axios.post(`${process.env.VUE_APP_AUTH_BASE_URL}/auth/login/gerid`,
        {
          env: this.env,
          tenant: this.tenant,
          access_token: user.access_token
        }
      )
      this.$store.commit('auth/login', result.data)
      await this.$router.push('/')

      // window.location.href = '/'
    }).catch(function () {
    })
  }
}
</script>
